<nz-modal [(nzVisible)]="isVisible" 
[nzTitle]="data?.id ? 'Edit Address' : 'Add a new Address'" 
[nzMaskClosable]="false" (nzOnCancel)="closeOnly()" [nzFooter]="modalFooter">
    <ng-container *nzModalContent>

        <!-- contact-form.component.html -->
        <form nz-form [formGroup]="addressForm">
            <!-- Client Address Section -->
            <fieldset>
                <nz-form-item>
                    <nz-form-label [nzSpan]="7" nzRequired>Address Type</nz-form-label>
                    <nz-form-control [nzSpan]="17" nzErrorTip="Please select a address type">
                        <nz-select nzShowSearch nzAllowClear formControlName="address_type" [compareWith]="compareById" nzPlaceHolder="Select A address type">
                            @for (clientAddress of clientAddressTypeList; track clientAddress.id) {
                            <nz-option [nzValue]="clientAddress" [nzLabel]="clientAddress.name + ' ' +'Address'"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                
                <nz-form-item>
                    <nz-form-label [nzSpan]="7" nzRequired>Address Field 1</nz-form-label>
                    <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid address">
                        <input nz-input formControlName="address_field_1" placeholder="Enter address line 1" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="7">Address Field 2</nz-form-label>
                    <nz-form-control [nzSpan]="17">
                        <input nz-input formControlName="address_field_2" placeholder="Enter address line 2" />
                    </nz-form-control>
                </nz-form-item>

               

                

                
                <nz-form-item>
                    <nz-form-label [nzSpan]="7" nzRequired>Country</nz-form-label>
                    <nz-form-control [nzSpan]="17" nzErrorTip="Please select a country">
                        <nz-select nzShowSearch nzAllowClear nzShowSearch  formControlName="country" [compareWith]="compareById" nzPlaceHolder="Select country">
                            @for (country of countries; track country.id) {
                            <nz-option [nzValue]="country" [nzLabel]="country.name"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="7" nzRequired>State</nz-form-label>
                    <nz-form-control [nzSpan]="17" nzErrorTip="Please select a state">
                        <nz-select nzShowSearch nzAllowClear formControlName="state" [compareWith]="compareById"  nzServerSearch  (nzOnSearch)="onSearchState($event)" nzPlaceHolder="Select state">
                            @for (state of states; track state.id) {
                            <nz-option [nzValue]="state" [nzLabel]="state.name"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="7" nzRequired>City</nz-form-label>
                    <nz-form-control [nzSpan]="17" nzErrorTip="Please select a city">
                        <nz-select nzShowSearch nzAllowClear formControlName="city" [compareWith]="compareById"  nzServerSearch  (nzOnSearch)="onSearchCity($event)" nzPlaceHolder="Select city">
                            @for (city of cities; track city.id) {
                            <nz-option [nzValue]="city" [nzLabel]="city.name"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                


                <nz-form-item>
                    <nz-form-label [nzSpan]="7" nzRequired>Postal/Zip Code</nz-form-label>
                    <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid postal code">
                        <input type="text" nz-input formControlName="zip_code"
                            placeholder="Enter postal/zip code" />
                    </nz-form-control>
                </nz-form-item>

               
            </fieldset>

        </form>

    </ng-container>


    <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="closeOnly()">Cancel</button>
        <button nz-button nzType="primary" [disabled]="!addressForm.valid"  (click)="close()">
            {{data?.id ? 'Update' : 'Add'}}
        </button>
    </ng-template>

</nz-modal>